import axios from "axios";

/**
 * Backend URL resolution:
 *
 * • In the browser we ALWAYS use `window.location.origin` — the ingress
 *   proxies `/api/*` to the backend on whichever host is loaded. This
 *   makes the same build run correctly on:
 *     – https://shift-flex-1.preview.emergentagent.com (preview)
 *     – https://shift-flex-1.emergent.host (production deployment)
 *     – http://localhost:3000 (local dev, when backend is proxied)
 *   and eliminates cross-origin cookie/CORS issues.
 *
 * • The `REACT_APP_BACKEND_URL` env var is used only when `window` is
 *   unavailable (SSR / build-time helpers). It never overrides the browser
 *   runtime origin.
 */
const BACKEND =
  typeof window !== "undefined"
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail, fallback = "Something went wrong. Please try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(path) {
  if (!path) return "";
  return `${API}/files/${path}`;
}
